import axios from "axios";
import { auth, firestore } from "firebase";
import router from "../../router";
export default {
  namespaced: true,
  state: {
    record: {},
    typeLogin: "",
    projects: [], //Proyectos disponibles para todos
    projectsPublic: [], //Proyectos publicos disponibles para todos
    projectsPrivate: [], //Proyectos privados de la persona logueada
    projectsRecommended: [], //Proyectos recomendados al usuario
    listRecommended: [], // Lista de proyectos recomendados en la collección usuario
    user: {},
    project: {},
    topic: {},
    topics: {},
    discussions: [],
    comments: [],
    milestone: [],
    currentUser: "",
    notifications: undefined,
  },
  actions: {
    cleanNotification({ commit }) {
      commit(`cleanNotification`);
    },

    requestRecord: async function({ state }) {
      await axios({
        method: "post",
        url:
          "https://us-central1-smartparticipa.cloudfunctions.net/authentication",
        headers: {
          Accept: "application/json"
        },
        data: {
          code: state.code
        }
      })
        .then(response => response)
        .catch(err => err);
    },
    listPublicProjects({ commit }) {
      // Proyectos Públicos
      firestore()
        .collection("Project")
        .where("visibility", "==", "public")
        .get()
        .then(querySnapshot => {
          let array = [];
          querySnapshot.forEach(doc => {
            let data = doc.data();
            data.project_id = doc.id;
            array.push(data);
          });
          commit(`insertPublicProjects`, array);
        });
    },
    listPrivateProject({ commit }) {
      // Proyectos privados
      let full_name = ""; //Nombre completo de la persona logueada
      let currentU = auth().currentUser;
      if (currentU != null) {
        let currentUser = auth().currentUser.uid;

        firestore()
          .collection("User")
          .doc(currentUser)
          .onSnapshot(function(result) {
            var data = result.data();
            full_name = data.first_name + " " + data.last_name;

            let notifications = data.projectsPending ? data.projectsPending : [] ;
            commit("insertNotifications", notifications);
            firestore()
              .collection("Project")
              .get()
              .then(querySnapshot => {
                let array = [];
                querySnapshot.forEach(doc => {
                  let data = doc.data();
                  const filterData = data.contributors.filter(
                    obj => obj.full_name === full_name.trim()
                  );
                  if (filterData.length) {
                    data.project_id = doc.id;
                    array.push(data);
                  }
                });
                // eslint-disable-next-line no-console
                console.log("Privados: ", array);
                commit(`insertPrivateProjects`, array);
              });
          });
      }
    },
    // eslint-disable-next-line no-empty-pattern
    listProjects({}) {
      /*
      state.projects = [];
      let arrayProjects = [];
      const currentUser = auth().currentUser;

      const getPublicProjects = arrayRecommended => {
        var flag = false;
        // Proyectos Públicos
        firestore()
          .collection("Project")
          .where("visibility", "==", "public")
          .get()
          .then(querySnapshot => {
            querySnapshot.forEach(doc => {
              flag = false;
              for(let i=0; i<arrayRecommended.length; i++){
                if(arrayRecommended[i].project_id == doc.id){
                  flag = true;
                }
              }
              if(flag){
                let data = doc.data();
                data.project_id = doc.id;
                arrayRecommended.push(data);
                flag = false;
              }
            });
            commit(`insertProjects`, arrayRecommended);
          });
      };

      const getAllPrivateProjects = array => {
        var flag = false;
        if (auth().currentUser !== null) {
          firestore()
            .collection("User") //gpfKvphbShgiPHSRrt5hz7mVtKS2
            .doc(currentUser.uid)
            .onSnapshot(function(result) {
              const data = result.data();
              const full_name = data.first_name + " " + data.last_name;
              firestore()
                .collection("Project")
                .where("visibility", "==", "private")
                .where("owner.full_name", "==", full_name)
                .get()
                .then(querySnapshot => {
                  querySnapshot.forEach(doc => {
                    flag = false;
                    for(let i=0; i<array.length; i++){
                      if(array[i].project_id == doc.id){
                        flag = true;
                      }
                    }
                    if(!flag){
                      let data = doc.data();
                      data.project_id = doc.id;
                      array.push(data);
                    }
                  });
                  commit(`insertProjectsPrivate`, array);
                  getPublicProjects(array);
                });
            });
        }
      };

      const getRecommededProjects = arrayRecommendedId => {
        var flag= false;
        let array = [];
        arrayRecommendedId.forEach(element => {
          firestore()
            .collection("Project")
            .doc(element)
            .onSnapshot(result => {
              flag = false;
              for(let i=0; i<arrayRecommendedId.length; i++){
                if(arrayRecommendedId[i].project_id == result.id){
                  flag = true;
                }
              }
              if(!flag){
                const data = result.data();
                data.project_id = result.id;
                data.isRecommended = true;
                array.push(data);
              }
          });
          getAllPrivateProjects(array);
        });
      };

      //  id de proyectos recomendados
      if (auth().currentUser !== null) {
        const idUser = auth().currentUser.uid;
        const funct = array => {
          commit(`insertRecommended`, array);
          if (array) {
            arrayProjects = array;
            getRecommededProjects(arrayProjects);
          } else getPublicProjects(arrayProjects);
        };
        firestore()
          .collection("User")
          .doc(idUser)
          .onSnapshot(function(result) {
            const data = result.data();
            funct(data.recommendedProjects);
          });
      } else {
        getPublicProjects(arrayProjects);
      }*/
    },
    listRecommended({ state, commit }) {
      const currentUser = auth().currentUser;
      if (currentUser !== null) {
        const idUser = auth().currentUser.uid;
        state.recommended = [];

        const getRecommendedProjectUsingArray = array => {
          let projects = [];

          array.forEach(element => {
            firestore()
              .collection("Project")
              .doc(element)
              .onSnapshot(result => {
                const data = result.data();
                data.project_id = result.id;
                data.isRecommended = true;
                projects.push(data);

                if (projects.length === array.length)
                  commit("insertProjectsRecommended", projects);
              });
          });
        };

        firestore()
          .collection("User")
          .doc(idUser)
          .onSnapshot(function(result) {
            const data = result.data();
            if (data.recommendedProjects)
              getRecommendedProjectUsingArray(data.recommendedProjects);
            else commit("insertProjectsRecommended", []);
          });
      }
    },
    validation() {
      const currentUser = auth().currentUser;
      if (currentUser !== null) {
        //commit(`insertUser`, currentUser);
        // eslint-disable-next-line no-console
        console.log("Validación exitosa");
      }
    },
    project({ commit }) {
      const projectID = router.currentRoute.params.project_id;

      firestore()
        .collection("Project")
        .doc(projectID)
        .onSnapshot(function(result) {
          let data = result.data();
          data.project_id = result.id;
          commit(`insertProject`, data);
          //commit(`insertUser`, data);
        });
    },
    onceProject({ commit }) {
      const projectID = router.currentRoute.params.project_id;
      const projectRef = firestore()
        .collection("Project")
        .doc(projectID);
      projectRef
        .get()
        .then(doc => {
          let data = doc.data();
          data.project_id = projectID;
          commit(`INSERT_ONCE_PROJECT`, data);
          commit(`milestones/SAVE_MILESTONE`, data.milestones, {
            root: true
          });
          // eslint-disable-next-line no-console
          console.log("Proyecto cargado.");
        })
        .catch(() => {
          // eslint-disable-next-line no-console
          console.log("El proyecto no fue cargado");
        });
    }
    /*
    
    */
  },
  mutations: {
    insertProjects: (state, projects) => {
      // eslint-disable-next-line no-console
      state.projects = projects;
    },
    insertNotifications: (state, array) => {
      state.notifications = array.map(element => { return { ...element, showed:true } });
    },
    cleanNotification: (state) => {
      state.notifications = undefined;
    },
    insertPublicProjects: (state, projects) => {
      state.projectsPublic = projects;
    },
    insertPrivateProjects: (state, projects) => {
      // eslint-disable-next-line no-console
      state.projectsPrivate = projects;
    },
    insertProjectsRecommended: (state, projects) => {
      state.projectsRecommended = projects;
    },
    insertRecommended: (state, array) => {
      state.listRecommended = array;
    },
    insertProject: (state, project) => {
      state.project = project;
    },
    INSERT_ONCE_PROJECT(state, project) {
      state.project = project;
    },
    /*
    insertUser: (state, user) => {
      const user_id = user.owner.full_name;

      firestore()
        .collection("User")
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            let data = doc.data();
            const name = data.fist_name + " " + data.last_name;

            if (name == user_id) {
              state.user = doc.data();
            }
          });
        });
    },*/
    insertMilestone: (state, milestone) => {
      state.project.milestones.push(milestone);
    },
    deleteMilestone: (state, description) => {
      state.project.milestones = state.project.milestones.filter(
        item => item.description !== description
      );
    }
  },
  getters: {
    getListProjects: state => {
      return state.projects;
    },
    getPendingProjects: state => {
      return state.notifications
    },
    getPublicsProjects: state => {
      return state.projectsPublic;
    },
    getPrivateProjects: state => {
      return state.projectsPrivate;
    },
    getRecommendedProjects: state => {
      return state.projectsRecommended;
    },
    getProject: state => {
      return state.project;
    },
    getFullName: state => {
      return `${state.user.first_name} ${state.user.last_name}`;
    },
    getUser: state => {
      return state.user;
    },
    getCurrentUser: state => {
      const user = auth().currentUser;
      if (user != null) {
        // eslint-disable-next-line no-console
        const displayName = user.providerData.reduce(item => item.displayName);
        state.currentUser = displayName.displayName;
      }
      return state.currentUser;
    }
  }
};
